// eslint-disable-next-line import/no-cycle
import { axiosUser } from "config/axios.config";
import { KEY_USER, KEY_USER_REMEMBER } from "config/app.config";

const AUTH_URL = "/auth";

const authSvc = {
  login: async (email, password) => {
    const response = await axiosUser.post(`${AUTH_URL}/login`, { email, password });
    localStorage.setItem(KEY_USER, JSON.stringify(response.data.data));
    return response;
  },
  register: async (body) => {
    const response = await axiosUser.post(`${AUTH_URL}/register`, body);
    localStorage.setItem(KEY_USER, JSON.stringify(response.data.data));
    return response;
  },
  registerV2: async (body) => {
    const response = await axiosUser.post(`${AUTH_URL}/register/v2`, body);
    localStorage.setItem(KEY_USER, JSON.stringify(response.data.data));
    return response;
  },
  logout: () => {
    localStorage.removeItem(KEY_USER);
    localStorage.clear();
  },
  getRemember: () => {
    return JSON.parse(localStorage.getItem(KEY_USER_REMEMBER));
  },
  setRemember: (email, password) => {
    localStorage.setItem(KEY_USER_REMEMBER, JSON.stringify({ email, password }));
  },
  removeRemember: () => {
    localStorage.removeItem(KEY_USER_REMEMBER);
  },
  changePassword: async (body) => {
    const response = await axiosUser.post(`${AUTH_URL}/change_password`, body);
    return response;
  },
  refresh: async (body) => {
    const response = await axiosUser.post(`${AUTH_URL}/refresh`, body);
    return response;
  },
  forgotPassword: async (body) => {
    const response = await axiosUser.post(`${AUTH_URL}/forgot_password`, body);
    return response;
  },
  resetPassword: async (body, token) => {
    const response = await axiosUser.patch(`${AUTH_URL}/reset_password/${token}`, body);
    return response;
  },
  sendVerification: async (body) => {
    const response = await axiosUser.post(`${AUTH_URL}/send_verification`, body);
    return response;
  },
  emailVerification: async (email) => {
    const response = await axiosUser.patch(`${AUTH_URL}/email_verification/${email}`);
    return response;
  },
  currentUser: () => {
    return JSON.parse(localStorage.getItem(KEY_USER));
  },
};

export default authSvc;
